import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Mail, Phone, MapPin } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contatti() {
  const [form, setForm] = useState({ nome: "", email: "", telefono: "", messaggio: "" });
  const [sending, setSending] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!form.nome || !form.email || !form.messaggio) {
      toast.error("Compila tutti i campi obbligatori");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contatti`, form);
      toast.success("Messaggio inviato — ti risponderò appena possibile");
      setForm({ nome: "", email: "", telefono: "", messaggio: "" });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Errore invio messaggio";
      toast.error(typeof msg === "string" ? msg : "Errore invio messaggio");
    } finally {
      setSending(false);
    }
  }

  return (
    <section id="contatti" data-testid="contatti-section" className="py-24 md:py-32 bg-[#1A1D1A] text-[#F9F8F6]">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <p className="eyebrow text-[#EFECE7]/70">06 — Contatti</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6">
            Scrivimi. <br />
            <span className="italic text-[#C9A985]">Rispondo personalmente.</span>
          </h2>
          <p className="text-[#EFECE7]/70 mt-6 max-w-md">
            Per informazioni, richieste di second opinion o chiarimenti prima di
            prenotare una visita.
          </p>

          <div className="mt-12 space-y-6 text-[15px]">
            <div className="flex items-start gap-4">
              <Mail className="w-4 h-4 mt-1 text-[#C9A985]" strokeWidth={1.5} />
              <div>
                <p className="eyebrow text-[#EFECE7]/60">Email</p>
                <p className="mt-1">manuel.gotti@hotmail.it</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Phone className="w-4 h-4 mt-1 text-[#C9A985]" strokeWidth={1.5} />
              <div>
                <p className="eyebrow text-[#EFECE7]/60">Telefono</p>
                <p className="mt-1">0382 503073</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <MapPin className="w-4 h-4 mt-1 text-[#C9A985]" strokeWidth={1.5} />
              <div>
                <p className="eyebrow text-[#EFECE7]/60">Sedi</p>
                <p className="mt-1">Pavia · Voghera</p>
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="lg:col-span-7 bg-[#22261F] border border-[#3A3F36] rounded-2xl p-6 md:p-10 space-y-6" data-testid="contact-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label htmlFor="c-nome" className="eyebrow text-[#EFECE7]/70">Nome</Label>
              <Input
                id="c-nome"
                data-testid="contact-nome"
                value={form.nome}
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
                className="mt-3 h-12 rounded-xl bg-[#1A1D1A] border-[#3A3F36] text-[#F9F8F6] placeholder:text-[#EFECE7]/40"
                required
              />
            </div>
            <div>
              <Label htmlFor="c-email" className="eyebrow text-[#EFECE7]/70">Email</Label>
              <Input
                id="c-email"
                type="email"
                data-testid="contact-email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-3 h-12 rounded-xl bg-[#1A1D1A] border-[#3A3F36] text-[#F9F8F6]"
                required
              />
            </div>
          </div>
          <div>
            <Label htmlFor="c-telefono" className="eyebrow text-[#EFECE7]/70">Telefono (facoltativo)</Label>
            <Input
              id="c-telefono"
              data-testid="contact-telefono"
              value={form.telefono}
              onChange={(e) => setForm({ ...form, telefono: e.target.value })}
              className="mt-3 h-12 rounded-xl bg-[#1A1D1A] border-[#3A3F36] text-[#F9F8F6]"
            />
          </div>
          <div>
            <Label htmlFor="c-messaggio" className="eyebrow text-[#EFECE7]/70">Messaggio</Label>
            <Textarea
              id="c-messaggio"
              data-testid="contact-messaggio"
              value={form.messaggio}
              onChange={(e) => setForm({ ...form, messaggio: e.target.value })}
              rows={5}
              className="mt-3 rounded-xl bg-[#1A1D1A] border-[#3A3F36] text-[#F9F8F6]"
              required
            />
          </div>
          <button
            type="submit"
            disabled={sending}
            data-testid="contact-submit"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#C9A985] text-[#1A1D1A] text-sm font-semibold hover:bg-[#D9BC98] disabled:opacity-60 transition-colors"
          >
            {sending ? "Invio…" : "Invia messaggio"}
            <span aria-hidden>→</span>
          </button>
        </form>
      </div>
    </section>
  );
}
